import { render, staticRenderFns } from "./WeChatOrderDetail.vue?vue&type=template&id=40d7f14c&"
import script from "./WeChatOrderDetail.vue?vue&type=script&lang=js&"
export * from "./WeChatOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports